// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__a4aIG","question":"Question_question__1oM32","description":"Question_description__1syjF"};